import { render, staticRenderFns } from "./homeWork.vue?vue&type=template&id=7d80d51b&scoped=true"
import script from "./homeWork.vue?vue&type=script&setup=true&lang=js"
export * from "./homeWork.vue?vue&type=script&setup=true&lang=js"
import style0 from "./homeWork.vue?vue&type=style&index=0&id=7d80d51b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d80d51b",
  null
  
)

export default component.exports